module.exports = __webpack_public_path__ + "img/type10001.8160f461.png";